import React, { useState } from "react";
import axiosInstance from "../../../../axios";

import "./subscribeNewsletters.scss";
const { REACT_APP_LOGIN_API_BASEURL } = process.env;

const SubscribeNewsletters = ({ buttonTitle, variant }) => {
  const [email, setEmail] = useState("");
  const [response, setResponse] = useState({ success: false });

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event, email) => {
    event.preventDefault();
    try {
      const data = await axiosInstance.post(`${REACT_APP_LOGIN_API_BASEURL}/user/linguisity?email=${email}`);
      setResponse((state) => ({ ...state, success: !data.error }));
    } catch (error) {
      setResponse(error);
    }
  };


  if (response.success) {
    return (
      <div className="subscribe response">
        <div>Thank you! our experts will be in touch with you soon.</div>
      </div>
    );
  }

  return (
    <div className={`subscribe ${variant}`}>
      <form onSubmit={(event) => handleSubmit(event, email)}>
        <input
          className="subscribe-email"
          type="email"
          value={email}
          onChange={handleChange}
          placeholder="Enter your email"
          required
        />
        <div className="btn-container">
          <button className="btn-desktop">
            <span>{buttonTitle}</span>{" "}
          </button>
          <button className="btn-mobile">
            <span>{buttonTitle}</span>{" "}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SubscribeNewsletters;
